import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useGetSmartFitResourceAvailablityHoursOptionsByTotalHours } from '~/modules/resourcing/hooks';
import { AllocationDistributionMode } from '~/types';
import { roundToDecimals } from '~/modules/resourcing/common/util/scheduleUtil';
import ResourceAssignmentSmartFitConfirmationDialog from '../ResourceAssignmentSmartFitConfirmationDialog';

const ShowSmartFitDialogOrLoading2 = ({
  resourceUser,
  totalAllocatedHours,
  allocationDateRange,
  createAllocationWithUserAndOverrideRules,
  closeShowSmartFitDialogOrLoading,
  scale
}) => {
  const {
    isLoading,
    smartFitmentDetails
  } = useGetSmartFitResourceAvailablityHoursOptionsByTotalHours({
    userUri: resourceUser.id,
    dateRange: allocationDateRange,
    hoursPerPeriod: totalAllocatedHours
  });

  const handleCreateAllocation = useCallback(
    (_, distributionMode) =>
      createAllocationWithUserAndOverrideRules(undefined, distributionMode),
    [createAllocationWithUserAndOverrideRules]
  );

  if (isLoading) return null;

  const { availableHoursWhatFits = 0 } = smartFitmentDetails || {};

  const hasEnoughAvailableHours =
    !smartFitmentDetails ||
    roundToDecimals(totalAllocatedHours) ===
      roundToDecimals(availableHoursWhatFits);

  if (hasEnoughAvailableHours) {
    createAllocationWithUserAndOverrideRules(
      undefined,
      AllocationDistributionMode.FitsAvailableHours
    );

    return null;
  }

  return (
    <ResourceAssignmentSmartFitConfirmationDialog
      smartFitmentDetails={smartFitmentDetails}
      scale={scale}
      resourceUser={resourceUser}
      createAllocationWithUserAndOverrideRules={handleCreateAllocation}
      closeShowSmartFitDialogOrLoading={closeShowSmartFitDialogOrLoading}
    />
  );
};

ShowSmartFitDialogOrLoading2.propTypes = {
  resourceUser: PropTypes.object,
  totalAllocatedHours: PropTypes.number,
  allocationDateRange: PropTypes.object,
  createAllocationWithUserAndOverrideRules: PropTypes.func,
  closeShowSmartFitDialogOrLoading: PropTypes.func,
  scale: PropTypes.string
};

export default ShowSmartFitDialogOrLoading2;
